import { motion } from "motion/react";
import { ReactNode } from "react";
import clsx from "clsx";

type Props = {
  children: ReactNode;
  onMouseLeave: () => void;
  className?: string;
};

export default function CreateEntityWrapper({ children, onMouseLeave, className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateX: "100%" }}
      animate={{ opacity: 1, translateX: "0" }}
      transition={{
        duration: 0.2,
      }}
      onMouseLeave={onMouseLeave}
      className={clsx(
        "fixed inset-y-[--boundary-offset-y] right-[--boundary-offset-x] z-[999]",
        "flex items-start",
        className,
      )}
    >
      {children}
    </motion.div>
  );
}
